module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis9-5589d3d8370b25423fedba22b14992ae.jpg";